import type { IconData } from '@stacksjs/iconify-core'

export const block1Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 1.5C11.574 1.5 1.5 11.574 1.5 24S11.574 46.5 24 46.5S46.5 36.426 46.5 24S36.426 1.5 24 1.5m3.062 19.198c-2.55-2.55-6.569-6.352-9.652-9.242A14.1 14.1 0 0 1 24 9.833c7.824 0 14.167 6.343 14.167 14.167c0 2.382-.588 4.625-1.625 6.594c-2.967-3.162-6.902-7.318-9.48-9.896M9.833 24c0-2.38.587-4.621 1.623-6.59c2.89 3.083 6.692 7.102 9.242 9.652c2.578 2.578 6.734 6.513 9.896 9.48A14.1 14.1 0 0 1 24 38.167c-7.824 0-14.167-6.343-14.167-14.167\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default block1Solid
